__turbopack_context__.v({
  "caption": "-iDqqG_caption",
  "containerRoot": "-iDqqG_containerRoot",
});
